export default __webpack_public_path__ + "static/media/background.2b210361.png";